/**
 * Get path for parent configuration object
 */
export function getParentPath(currentPath) {
    const attributePath = currentPath.slice(0, currentPath.lastIndexOf("/")) || "/";
    const parentPath = attributePath.slice(0, attributePath.lastIndexOf("/")) || "/";
    return parentPath;
}
//# sourceMappingURL=getParentPath.js.map